export const Menu = 'menu/1';
export const Social ='website/social'
export const TopBar ='website/contacts'
export const Style ='website/style'
export const Gallery = 'website/gallery'
export const Sponsors = '/website/Sponsors'
export const Blog = 'website/blog'
export const contactform ='contact'
export const BookingForm ='clientbooking'
export const Floorplan ='floorplansubmit'
export const subscribeform ='subscribe'
export const Login ='login'
export const TrustedPartners ='topics/20/page/1/count/100/en'
export const mediapartners ='topics/17/page/1/count/100/en'
export const eventpartners ='topics/23/page/1/count/100/en'
export const brochure ='topics/18/page/1/count/10/en'
export const Countdown ='topics/19/page/1/count/10/en'

